import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { Baseurl } from '../../config/BaseUrl'
import axios from 'axios'
import { format } from 'date-fns';
import moment from 'moment/moment';

const EditReport2 = () => {
    const params = useParams()
    const navigation = useNavigate()
    const { currentCase } = useSelector((state) => state.cases)
    const [loanAgmtNo, setLoanAgmtNo] = useState('');
    const [docVerified, setDocVerified] = useState('');
    const [regOwnerName, setRegOwnerName] = useState('');
    const [regDate, setRegdate] = useState('');
    const [mfgDate, setMfgdate] = useState('');
    const [numberPlateType, setNumberPlateType] = useState('');
    const [regNumber, setRegNumber] = useState('');
    const [engineNo, setEngineNo] = useState('');
    const [chasisNo, setChasisNo] = useState('');
    const [bodyType, setBodyType] = useState('');
    const [meterReading, setMeterReading] = useState('');
    const [fuelType, setFuelType] = useState('');
    const [vehicleColor, setVehicleColor] = useState('');
    const [grossWeight, setGrossWeight] = useState('');
    const [ownerSerial, setOwnerSerial] = useState('');
    const [hypothecationBank, setHypothecationBank] = useState('');
    const [insuranceCompany, setInsuranceCompany] = useState('');
    const [insuranceStatus, setInsuranceStatus] = useState('');
    const [cubicCapacity, setCubicCapacity] = useState('');
    const [seatingCapacity, setSeatingCapacity] = useState('');
    const [exteriorRemark, setExteriorRemark] = useState('');


    useEffect(() => {
        const fetchData = async () => {
            const caseId = params.id;
            const url = `${Baseurl}/api/v1/cases/individualcase/${caseId}`;
            const caseFetch = await axios.get(url);
            const data = caseFetch.data.case
            setLoanAgmtNo(data.loanAgreementNo);
            setDocVerified(data.documentVerification);
            setRegOwnerName(data.regdOwner);
            // setRegdate(data.regdDate);
            // setMfgdate(
            //     data.manufacturingDate,
            // );
            setNumberPlateType(data.numberPlate);
            setRegNumber(data.regdNo);
            setEngineNo(data.engNo);
            setChasisNo(data.chasisNo);
            setBodyType(data.bodyType);
            setMeterReading(data.meterReading);
            setFuelType(data.fueltype);
            setVehicleColor(data.vehicleColor);
            setGrossWeight(data.vehicleWeight);
            setOwnerSerial(data.ownerSerialNo);
            setHypothecationBank(data.hypothecationBank);
            setInsuranceCompany(data.insuranceCompany)
            setInsuranceStatus(data.insuranceStatus)
            setCubicCapacity(data.cubicCapacity);
            setSeatingCapacity(data.seatingCapacity);
            setExteriorRemark(data.extriorRemark);
        }
        fetchData()
    }, [params.id])

    const handleRegdDate = (e) => {
        setRegdate(e.target.value)
    }

    const documents = [
        { name: 'Verified', id: 1 },
        { name: 'Not Verified', id: 2 },
    ];
    const selectDocuementVerifiedTypeChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setDocVerified(text);
    };
    const number = [
        { name: 'White', id: 1 },
        { name: 'Yellow', id: 2 },
        { name: 'Blue', id: 3 },
        { name: 'Black', id: 4 },
    ];
    const selectNumberPlateTypeChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setNumberPlateType(text);
    };
    const fourWheelerBody = [
        { name: 'Salsoon', id: 1 },
        { name: 'Sedans', id: 2 },
        { name: 'Hatchbacks', id: 3 },
        { name: 'SUVs', id: 4 },
        { name: 'MUVs', id: 5 },
        { name: 'Coupes', id: 6 },
    ];
    const threeWheelerBody = [
        { name: 'Closed', id: 1 },
    ];
    const farmEquipment = [
        { name: 'Car', id: 1 },
    ];
    const constructionBody = [
        { name: 'Motor Graders', id: 1 },
        { name: 'Trenchers', id: 2 },
        { name: 'Excavators', id: 3 },
        { name: 'Common Dump Trucks', id: 4 },
        { name: 'Crawler Loaders', id: 5 },
        { name: 'Skid Steer Loaders', id: 6 },
        { name: 'Scrapers', id: 7 },
        { name: 'Bulldozers', id: 8 },
        { name: 'Backhoe Loader', id: 9 },
    ];
    const twoWheelerBody = [
        { name: 'standard', id: 1 },
        { name: 'cruiser', id: 2 },
        { name: 'touring', id: 3 },
        { name: 'sports', id: 4 },
        { name: 'off-road', id: 5 },
        { name: 'dual-purpose', id: 6 },
    ];
    const fuel = [
        { name: 'Petrol', id: 1 },
        { name: 'Diesel', id: 2 },
        { name: 'Ev', id: 3 },
    ];
    const selectFuelTypeChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setFuelType(text);
    };
    const options = [
        { name: 'Yes', id: 1 },
        { name: 'No', id: 2 },
    ];

    const selectInsuranceStatusChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setInsuranceStatus(text);
    };
    const handleCaseUpdate = async () => {
        const formData = {
            loanAgreementNo: loanAgmtNo,
            documentVerification: docVerified,
            regdOwner: regOwnerName,
            regdDate: regDate,
            manufacturingDate: mfgDate,
            numberPlate: numberPlateType,
            regdNo: regNumber,
            engNo: engineNo,
            chasisNo: chasisNo,
            bodyType: bodyType,
            meterReading: meterReading,
            fueltype: fuelType,
            vehicleColor: vehicleColor,
            vehicleWeight: grossWeight,
            ownerSerialNo: ownerSerial,
            hypothecationBank: hypothecationBank,
            insuranceCompany: insuranceCompany,
            insuranceStatus: insuranceStatus,
            cubicCapacity: cubicCapacity,
            seatingCapacity: seatingCapacity,
            extriorRemark: exteriorRemark,
        };
        console.log(formData, "formData");
        const config = {
            Headers: { 'Content-Type': 'application/json' },
        };
        const url = `${Baseurl}/api/v1/cases/updatecase/${params.id}`;
        const resp = await axios.put(url, formData, config);
        if (resp.data.success) {
            navigation(`/admin/editreport3/${params.id}`)
        }
    }


    return (
        <>
            <div className="min-h-screen flex flex-col lg:ps-64 w-full">
                <div className="p-6 space-y-6">
                    <div className="flex items-center justify-between w-full print:hidden">
                        <h4 className="text-lg font-semibold text-default-900">
                            Edit Case Details
                        </h4>
                    </div>
                    <div className="shadow rounded-lg bg-white dark:bg-default-50 h-fit">
                        <div className="flex items-center justify-between py-4 px-5">
                            <h4 className="text-lg font-medium text-default-950 capitalize">
                                Edit Case Details
                            </h4>
                        </div>
                        <div className="p-5 border-t border-dashed border-default-200">
                            <div className="grid md:grid-cols-2 gap-4">
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fLoanAgreement"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Loan Agreement No *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fLoanAgreement"
                                        placeholder="Enter Loan Agreement No"
                                        value={loanAgmtNo}
                                        onChange={(e) => setLoanAgmtNo(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fDocVerified"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Document Verified *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="fDocVerified"
                                        placeholder="This is a search placeholder"
                                        value={documents.id}
                                        name={documents.name}
                                        onChange={(e) =>
                                            selectDocuementVerifiedTypeChange(e)
                                        }
                                    >
                                        <option value="0" hidden selected>
                                            Choose Status
                                        </option>
                                        {documents.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === docVerified}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fRegdOwner"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Registered Owner Name *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fRegdOwner"
                                        placeholder="Enter Regd owner Name"
                                        value={regOwnerName}
                                        onChange={(e) => setRegOwnerName(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fRegistrationDate"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Registration Date  <span style={{color:'red'}}>**</span>
                                    </label>
                                    <input
                                        type="date"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fRegistrationDate"
                                        placeholder="Enter Registration Date"
                                        value={regDate}
                                        onChange={(e) => {
                                            handleRegdDate(e)
                                        }}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fManufacturingDate"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Manufacturing Date <span style={{color:'red'}}>**</span>
                                    </label>
                                    <input
                                        type="date"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fManufacturingDate"
                                        placeholder="Enter Manufacturing Date"
                                        value={mfgDate}
                                        onChange={(e) => setMfgdate(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fNumberPlate"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Number Plate Type *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="fNumberPlate"
                                        placeholder="This is a search placeholder"
                                        value={number.id}
                                        name={number.name}
                                        onChange={(e) =>
                                            selectNumberPlateTypeChange(e)
                                        }
                                    >
                                        <option value="0" hidden selected>
                                            Choose Number Plate Type
                                        </option>
                                        {number.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === numberPlateType}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fRegNumber"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Registration Number *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fRegNumber"
                                        placeholder="Enter Registration Number"
                                        value={regNumber}
                                        onChange={(e) => setRegNumber(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fEngineNo"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Engine No *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fEngineNo"
                                        placeholder="Enter Engine No"
                                        value={engineNo}
                                        onChange={(e) => setEngineNo(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fChasis"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Chasis No *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fChasis"
                                        placeholder="Enter Chasis No"
                                        value={chasisNo}
                                        onChange={(e) => setChasisNo(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fBodyType"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Body Type *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fBodyType"
                                        placeholder="Enter Body Type"
                                        value={bodyType}
                                        onChange={(e) => setBodyType(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fMeterReading"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Meter Reading *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fMeterReading"
                                        placeholder="Enter Meter Reading"
                                        value={meterReading}
                                        onChange={(e) => setMeterReading(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fFuelType"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Fuel Type *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="fFuelType"
                                        placeholder="This is a search placeholder"
                                        value={fuel.id}
                                        name={fuel.name}
                                        onChange={(e) =>
                                            selectFuelTypeChange(e)
                                        }
                                    >
                                        <option value="0" hidden selected>
                                            Choose Fuel Type
                                        </option>
                                        {fuel.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === fuel}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fVehicleColor"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Vehicle Color *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fVehicleColor"
                                        placeholder="Enter Vehicle Color"
                                        value={vehicleColor}
                                        onChange={(e) => setVehicleColor(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fGrossWeight"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Gross Weight Of Vehicle *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fGrossWeight"
                                        placeholder="Enter Gross Weight Of Vehicle"
                                        value={grossWeight}
                                        onChange={(e) => setGrossWeight(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fOwnerSerial"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Owner Serial No*
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fOwnerSerial"
                                        placeholder="Enter Owner Serial"
                                        value={ownerSerial}
                                        onChange={(e) => setOwnerSerial(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fHypothecationBank"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Hypothecation Bank Name *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fHypothecationBank"
                                        placeholder="Enter Hypothecation Bank Name"
                                        value={hypothecationBank}
                                        onChange={(e) => setHypothecationBank(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fInsuranceCompany"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Insurance Company Name *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fInsuranceCompany"
                                        placeholder="Enter Insurance Company Name"
                                        value={insuranceCompany}
                                        onChange={(e) => setInsuranceCompany(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fInsuranceStatus"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Insurance Expired *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="fInsuranceStatus"
                                        placeholder="This is a search placeholder"
                                        value={options.id}
                                        name={options.name}
                                        onChange={(e) =>
                                            selectInsuranceStatusChange(e)
                                        }
                                    >
                                        <option value="0" hidden selected>
                                            Choose Insurance Status
                                        </option>
                                        {options.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === insuranceStatus}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fCubicCapacity"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Cubic Capacity *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fCubicCapacity"
                                        placeholder="Enter Cubic Capacity"
                                        value={cubicCapacity}
                                        onChange={(e) => setCubicCapacity(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fSeatingCapacity"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Seating Capacity *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fSeatingCapacity"
                                        placeholder="Enter Seating Capacity"
                                        value={seatingCapacity}
                                        onChange={(e) => setSeatingCapacity(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fExteriorRemark"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Exterior Remark *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fExteriorRemark"
                                        placeholder="Enter Exterior Remark"
                                        value={exteriorRemark}
                                        onChange={(e) => setExteriorRemark(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="flex items-center gap-2 justify-end" style={{ marginBottom: '80px' }}>
                                <button
                                    style={{ background: "#ef4444", color: '#fff', border: 'none', outline: 'none' }}
                                    className="py-2 px-5 inline-flex items-center justify-center gap-2 font-semibold tracking-wide border border-transparent align-middle duration-500 text-sm text-center text-red-600 hover:border-red-500/20 hover:bg-red-500/20 rounded transition-all"
                                    onClick={() => navigation(`/admin/editreport/${params.id}`)}
                                >
                                    <i className="ph-bold ph-x text-lg" />Go Back
                                </button>
                                <button
                                    className="py-2 px-5 inline-flex items-center justify-center gap-2 font-semibold tracking-wide border align-middle duration-500 text-sm text-center bg-default-800 hover:bg-default-950  text-default-50 rounded"
                                    style={{ background: "#8481ff", border: 'none', outline: 'none' }}
                                    onClick={() => handleCaseUpdate()}
                                >
                                    <i className="ph-duotone ph-cloud-arrow-up text-lg" />
                                    Next
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EditReport2